import React from 'react'
import classnames from 'classnames'
import Svg from 'react-inlinesvg'

import logoMark from '../../assets/PaymentsOS-logomark.svg'
import logoText from '../../assets/PaymentsOS-logotype.svg'

import style from './style.scss'

const Logo: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => (
  <div
    data-test='menu-paymentsos-logo'
    className={classnames(style.logo, {
      [style['logo--small']]: collapsed
    })}
  >
    <Svg className={style.logo__mark} key={logoMark} src={logoMark} />
    <Svg className={style.logo__text} key={logoText} src={logoText} />
  </div>
)

export default Logo
